import { BoloPanelTab } from '../bolo-panel-tab';
import { TabBody } from '../../../../../panels/entity-panels/tabs/tab-body';
import { EntityLog } from '../../../../../panels/entity-panels/entity-log/entity-log';
import { useBoloPanelLog } from '../../../state/use-bolo-panel-log';
import { observer } from 'mobx-react-lite';

export const BoloLogTabContent = observer(({ boloId }: { boloId: number }) => {
    const { isLoading, boloLog } = useBoloPanelLog(boloId);

    return (
        <BoloPanelTab title="BOLO Log">
            <TabBody constrainToParentHeight={true}>
                <EntityLog
                    isLoading={isLoading}
                    actions={boloLog?.data?.data?.elasticUserActionSearchResult?.items ?? []}
                />
            </TabBody>
        </BoloPanelTab>
    );
});
